import { Configuration, LogLevel } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_AAD_TENANT_ID;
const clientId = import.meta.env.VITE_AAD_CLIENT_ID;
const apiScope = import.meta.env.VITE_API_SCOPE;

if (!tenantId || !clientId) {
  // eslint-disable-next-line no-console
  console.warn("MSAL config missing VITE_AAD_TENANT_ID / VITE_AAD_CLIENT_ID");
}

// Redirect bridge de MSAL v5 (blank.html): destino de todos los flujos, login por
// redirect y renovaciones silenciosas del iframe oculto. Es una página vacía que
// no carga el portal. Debe estar registrada como redirect URI (SPA) en Entra ID.
export const silentRedirectUri = window.location.origin + "/blank.html";

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "PLACEHOLDER",
    authority: `https://login.microsoftonline.com/${tenantId ?? "common"}`,
    redirectUri: silentRedirectUri,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: () => {},
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read", apiScope ?? ""].filter(Boolean),
};

export const apiRequest = {
  scopes: [apiScope ?? ""].filter(Boolean),
};


